<div class="wrap">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div class="uk-form-horizontal uk-margin-large" uk-grid *ngIf="loading === false" style="margin-left: -40px;">

        <!-- Price form -->
        <div class="uk-width-10-10">
            <div class="title bold uk-margin-bottom">
                <span>Gestion de la tarification sur les vehicules de l'adherent selectionné</span>
            </div>
        </div>

        <div class="uk-width-6-10@s">
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Type</label>
                <div style="margin-left: 15px" uk-form-custom="target: > * > span:first-child">
                    <select [(ngModel)]="prices.price_type">
                        <option value="hour_prices">Par heure</option>
                        <option value="blocks">Par bloc</option>
                    </select>
                    <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                        <span uk-icon="icon: chevron-down" class="uk-margin-small-left"></span>
                    </button>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.price_type === 'blocks'">
                <label class="uk-form-label" for="form-horizontal-text">Horaires par bloc</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-2 subtitle">
                        Bloc 1
                    </div>
                    <div class="uk-width-1-2 subtitle">
                        Bloc 2
                    </div>

                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[0].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[0].end">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[1].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[1].end">
                    </div>

                    <div class="uk-width-1-2 subtitle uk-margin-small-top">
                        Bloc 3
                    </div>
                    <div class="uk-width-1-2 subtitle uk-margin-small-top">
                        Bloc 4
                    </div>

                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[2].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[2].end">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[3].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[3].end">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.price_type === 'blocks'">
                <label class="uk-form-label" for="form-horizontal-text">Prix par bloc</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-4 subtitle">
                        Bloc 1
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 2
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 3
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 4
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[0].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[1].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[2].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" type="number" [(ngModel)]="prices.block_list[3].amount">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.price_type === 'hour_prices'">
                <label class="uk-form-label" for="form-horizontal-text">Prix horaire</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-4 subtitle">
                        Lundi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Mardi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Mercredi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Jeudi
                    </div>

                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[0]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[1]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[2]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[3]">
                    </div>

                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Vendredi
                    </div>
                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Samedi
                    </div>
                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Dimanche
                    </div>

                    <div class="uk-widith-1-4"></div>

                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[4]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[5]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="input alt uk-text-center" min="0" step="0.1" type="number"
                            [(ngModel)]="prices.hour_price_list[6]">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.price_type === 'hour_prices'">
                <label class="uk-form-label" for="form-horizontal-text">Maximum d'heures comptabilisé</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip small-font">h/jour</span>
                    <input class="input alt" min="0" max="24" step="1" type="number"
                        [(ngModel)]="prices.limited_hour_day">
                </div>
            </div>
        </div>
        <div class="uk-width-4-10@s" style="padding-right: 20px;">
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Prix au kilomètre</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip small-font">€/km</span>
                    <input class="input alt" min="0" step="0.1" type="number" [(ngModel)]="prices.km_price">
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Prix de la réservation</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip small-font">€</span>
                    <input class="input alt" min="0" type="number" [(ngModel)]="prices.reservation_price">
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Carburant inclus</label>

                <div style="margin-left: 15px" uk-form-custom="target: > * > span:first-child">
                    <select [(ngModel)]="prices.fuel_included">
                        <option [ngValue]="1">Oui</option>
                        <option [ngValue]="0">Non</option>
                    </select>
                    <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                        <span uk-icon="icon: chevron-down" class="uk-margin-small-left"></span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modifiers -->
        <!-- <div class="uk-width-4-10">
            <div class="title bold">Préconfigurations</div>
            <div uk-grid class="presets">
                <div class="uk-width-1-1">
                    <button (click)="updatePriceFormFromModel(1)" class="uk-width-1-1 button">
                        Modèle par heure
                    </button>
                </div>
                <div class="uk-width-1-1">
                    <button (click)="updatePriceFormFromModel(2)" class="uk-width-1-1 button">
                        Modèle par bloc
                    </button>
                </div>
            </div>
        </div> -->

        <!-- Discounts -->
        <div class="uk-width-10-10 uk-margin-large-top" style="padding-right: 20px;">
            <div class="title bold uk-margin-bottom">
                <span>Remises</span>
                <div class="uk-float-right">
                    <button class="back-button regular" (click)="addDiscount()">
                        <span class="uk-text-uppercase">Ajouter</span>
                        <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>

            <div *ngIf="prices.discount_list.length === 0">
                <span>Aucune remise n'est appliquée.</span>
            </div>

            <div *ngFor="let discount of prices.discount_list; let i = index">
                <div class="uk-form-controls uk-grid-small" uk-grid
                    style="margin-left: -15px; margin-top: 0px; margin-bottom: 15px;">
                    <div class="uk-width-1-1 discount-margin">
                        <input class="input alt uk-text-center" min="0" style="width: 85px;" type="number"
                            [(ngModel)]="discount.amount">
                        <div uk-form-custom="target: > * > span:first-child">
                            <select [ngModel]="discount.symbol" (ngModelChange)="changeSymbol(i, $event)">
                                <option value="%">%</option>
                                <option value="€">€</option>
                                <option value="km">KM</option>
                            </select>
                            <button class="uk-button uk-button-default" type="button" tabindex="-1">
                                <span></span>
                                <span uk-icon="icon: chevron-down" class="uk-margin-small-left"></span>
                            </button>
                        </div>
                        <span *ngIf="discount.symbol === '%' || discount.symbol === '€'">à partir de</span>
                        <span *ngIf="discount.symbol === 'km'">inclus pour chaque</span>
                        <input *ngIf="discount.symbol !== 'km'" min="0" class="input alt uk-text-center"
                            style="width: 85px;" type="number" [(ngModel)]="discount.conditionAmount">
                        <span *ngIf="discount.symbol === '%' || discount.symbol === '€'">jusqu'à</span>
                        <input *ngIf="discount.symbol === '%' || discount.symbol === '€'" min="0"
                            class="input alt uk-text-center" style="width: 85px;" type="number"
                            [(ngModel)]="discount.conditionAmountMax">
                        <div uk-form-custom="target: > * > span:first-child">
                            <select [(ngModel)]="discount.condition">
                                <option value="kilometers" *ngIf="discount.symbol !== 'km'">KM parcourus</option>
                                <option value="hours">heures réservées</option>
                                <option value="blocks">blocs réservés</option>
                            </select>
                            <button class="uk-button uk-button-default" type="button" tabindex="-1">
                                <span></span>
                                <span uk-icon="icon: chevron-down" class="uk-margin-small-left"></span>
                            </button>
                        </div>
                        <button class="uk-button uk-button-link" (click)="removeDiscount(i)">
                            <img style="right: 10px; filter: brightness(200%);" src="../../../assets/icons/delete.svg"
                                width="32px" height="32px" alt="delete" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="bold uk-float-right uk-margin-medium-top">
                <div>
                    <!-- <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                        [(ngModel)]="vehicle.vehicleCategeory"> -->
                    <!-- <span *ngIf="vehicle.vehicleCategeory == 'A'" class="material-icons color-black vertical-align-middle iconFuel">directions_car</span>
                    <span *ngIf="vehicle.vehicleCategeory == 'B'" class="material-icons color-black vertical-align-middle iconFuel">local_taxi</span>
                    <span *ngIf="vehicle.vehicleCategeory == 'C'" class="material-icons color-black vertical-align-middle iconFuel">airport_shuttle</span>
                    <span *ngIf="vehicle.vehicleCategeory == 'D'" class="material-icons color-black vertical-align-middle iconFuel">local_shipping</span>
                    <span *ngIf="vehicle.vehicleCategeory == 'E'" class="material-icons color-black vertical-align-middle iconFuel">directions_bus</span> -->
                    <select class="combo-list alt color-cold-grey bold uk-width-1-1 uk-align-left labelFuel"
                        [(ngModel)]="categorie">
                        <option *ngFor="let category of categories; let i = index" value={{category.value}}>{{category.key}}
                        </option>
                        <!-- <option value="A">Citadine (A)</option>
                        <option value="B">Routiere (B)</option>
                        <option value="C">Familiale (C)</option>
                        <option value="D">Utilitaire (D)</option>
                        <option value="E">Autre (E)</option> -->
                    </select>
                </div>
                <button class="button" (click)="updateTarification()" [disabled]="categorie == '0'">
                    <span>Mettre à jour la tarification</span>
                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                </button>
            </div>
        </div>

        <!-- Simulations -->
        <!-- <div *ngIf="false" class="uk-width-10-10 uk-margin-large-top">
            <!--style="padding-right: 20px;" 
            <div class="title bold uk-margin-bottom">
                <span>Simulateur</span>
                <div class="uk-float-right">
                    <!-- <button class="back-button regular" (click)="updateSimulations()">
                        <span class="uk-text-uppercase">Rafraîchir</span>
                        <span class="material-icons vertical-middle">refresh</span>
                    </button> 
                    <button class="back-button regular" (click)="addSimulation()">
                        <span class="uk-text-uppercase">Ajouter</span>
                        <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>

            <div *ngIf="simulations.length === 0">
                <span>Aucune simulation n'est enregistrée.</span>
            </div>

            <div uk-grid>
                <div class="uk-width-1-2@s" *ngFor="let simulation of simulations; let i = index">
                    <div class="uk-form-horizontal uk-grid-small" uk-grid>
                        <div class="uk-width-1-1 uk-position-relative uk-card card">
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Début</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="input alt uk-text-center" type="datetime-local"
                                        [(ngModel)]="simulation.start">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Fin</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="input alt uk-text-center" type="datetime-local"
                                        [(ngModel)]="simulation.end">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">KM
                                    parcourus</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="input alt uk-text-center" min="0" type="number"
                                        [(ngModel)]="simulation.kilometers">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Durée
                                    totale</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="input alt uk-form-blank uk-text-center" type="text" [(ngModel)]="simulation.totalTime" disabled> 
                                    <legend class="uk-legend">{{simulation.totalTime}}</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant
                                    kilométrique</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.kmAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant
                                    horaire</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.hourAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant
                                    réservation</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.reservationAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant
                                    remises</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.discountAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant
                                    total</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.totalAmount}}€</legend>
                                </div>
                            </div>
                            <div class="delete-simulation">
                                <button class="back-button regular" (click)="updateSimulations()">
                                    <span class="material-icons vertical-middle">refresh</span>
                                </button>
                                <button class="uk-button uk-button-link" (click)="removeSimulation(i)">
                                    <img style="right: 10px; filter: brightness(200%);"
                                        src="../../../assets/icons/delete.svg" width="32px" height="32px"
                                        alt="delete" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>